import NoFunds from './noFunds'
import AccessPay from './accessPay'
import useGetFunds from './hooks/useGetFunds'
import DotsLoading from 'components/loadings/dotsLoading'
import MoneyPools from './moneyPools'
import CashBoxes from './cashBoxes'

export default function Funds() {
    const { moneyPools, cashBoxes, isLoading } = useGetFunds()
    return (
        <div className="bg-white min-h-screen">
            {isLoading ? (
                <DotsLoading />
            ) : !moneyPools ? (
                <DotsLoading />
            ) : moneyPools.length > 0 ? (
                <>
                    <AccessPay />
                    <div className="px-4 pt-4 pb-[60px]">
                        {cashBoxes && <CashBoxes cashBoxes={cashBoxes} />}
                        <MoneyPools moneyPools={moneyPools} />
                    </div>
                </>
            ) : (
                <NoFunds />
            )}
        </div>
    )
}
